import { useMemo } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { usePermissionsListQuery } from '@/modules/role/queries';
import { IPermissionGroup } from '@/modules/role/role.types';


const useGrantedPermissions = (keys?: OptionKey[]) => {

  const {groups} = usePermissionsListQuery({});

  const {granted, revoked} = useMemo(() => {
    const grantedList: IPermissionGroup[] = groups.map((group)  => {
      const filteredOptions = group.options.filter((item) =>  keys?.includes(item.key));
      return {
        id: group.id,
        name: group.name,
        options: filteredOptions
      };
    });
    const filteredGrantedList = grantedList.filter((item) => item.options.length);

    const revokedList: IPermissionGroup[] = groups.map((group)  => {
      const filteredOptions = group.options.filter((item) =>  !keys?.includes(item.key));
      return {
        id: group.id,
        name: group.name,
        options: filteredOptions
      };
    });
    const filteredRevokedList = revokedList.filter((item) => item.options.length);

    return {
      granted: filteredGrantedList,
      revoked: filteredRevokedList
    };

  }, [groups, keys]);
  return {
    granted,
    revoked
  };
};


export default useGrantedPermissions;